const NAME_PATTERN = /^[a-zA-Z0-9ぁ-んァ-ン一-龥\sー]*$/;
const CONTACT_NAME_PATTERN = /^[a-zA-Zぁ-んァ-ン一-龥\sー]*$/;
const EMAIL_PATTERN =
  /^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;
const PASSWORD_PATTERN =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d!"#$%&'()*+,-./\\:;<=>?@[\]^_`{|}~]*$/;
const NUMBER_PATTERN = /^[0-9]\d*$/;
const PHONE_NUMBER_LENGTH_PATTERN = /^\d{10,11}$/;
const POSTAL_CODE_PATTERN = /^\d{7,7}$/;
const NEGATIVE_NUMBER_PATTERN = /^-?(?!0)\d*$/;

export {
  CONTACT_NAME_PATTERN,
  EMAIL_PATTERN,
  NAME_PATTERN,
  NEGATIVE_NUMBER_PATTERN,
  NUMBER_PATTERN,
  PASSWORD_PATTERN,
  PHONE_NUMBER_LENGTH_PATTERN,
  POSTAL_CODE_PATTERN,
};
